import React from "react";
import {
  Compass,
  Target,
  Clapperboard,
  Truck,
  CircuitBoard,
  Sparkles,
  Bot,
  Brain,
  Rocket,
  Layers,
  Lightbulb,
  LineChart,
  Telescope,
  Map,
  GraduationCap,
  FileText,
  LayoutTemplate,
  Image as ImageIcon,
  Users,
  Activity,
  PackageCheck,
  Scale,
  MessageCircle,
} from "lucide-react";

const MAP = {
  Compass,
  Target,
  Clapperboard,
  Truck,
  CircuitBoard,
  Sparkles,
  Bot,
  Brain,
  Rocket,
  Layers,
  Lightbulb,
  LineChart,
  Telescope,
  Map,
  GraduationCap,
  FileText,
  LayoutTemplate,
  Image: ImageIcon,
  Users,
  Activity,
  PackageCheck,
  Scale,
  MessageCircle,
};

export function GPTIcon({ name, size = 22, className = "" }) {
  const Cmp = MAP[name] || Bot;
  return <Cmp size={size} strokeWidth={1.5} className={className} />;
}

export const AVAILABLE_ICONS = Object.keys(MAP);
